import { Component } from '@angular/core';

import { ToastService } from '../../../core/services/ui/toast.service';

@Component({
  selector: 'app-toast',
  standalone: true,
  imports: [],
  templateUrl: './toast.html',
  styleUrl: './toast.scss'
})
export class Toast {

  readonly toasts;

  constructor(
    private readonly toastService: ToastService
  ) {
    this.toasts = this.toastService.toasts;
  }

  close(id: number): void {
    this.toastService.remove(id);
  }

  icon(type: string): string {
    switch (type) {
      case 'success':
        return 'bi-check-lg';

      case 'error':
        return 'bi-x-lg';

      case 'warning':
        return 'bi-exclamation-lg';

      case 'info':
        return 'bi-info-lg';

      default:
        return 'bi-info-lg';
    }
  }
}